module.exports = __webpack_public_path__ + "static/media/rocket-spike.982bfe4e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rocket-spike.png
// module id = 57
// module chunks = 0